import React, { useEffect, useState, useRef } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { MdOutlineMail, MdOutlineErrorOutline } from "react-icons/md";
import { BsXLg } from "react-icons/bs";
import {Jodit} from "jodit"
import JoditEditor from "jodit-react"; 
import { getEmailSignatureList, getEmailTemplateList, sendRawEmail } from '../../utils/awsAPI';
import { useDispatch, useSelector } from 'react-redux';
import { RiCloseCircleLine, RiSendPlaneLine } from "react-icons/ri";
import { getEmailSenderList } from '../../utils/utils';
import { emailSliceAction } from '../../store/emailSlice';

let OptionsJodit = Jodit.defaultOptions

const Dailpad = () => {
    const dispatch = useDispatch()
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const emailDetails = useSelector((state:any)=>{return state.emailSlice.emailDetails})
    const emailAction = useSelector((state:any)=>{return state.emailSlice.emailAction})
    const [show, setShow] = useState(false)
    const [isDisabled, setIsDisabled] = useState(false)
    const [isEnableCC, setIsEnableCC] = useState(false)
    const [isEnableBCC, setIsEnableBCC] = useState(false)
    const [mailTo,setMailTo] = useState<any>([])
    const [mailCC,setMailCC] = useState<any>([])
    const [mailBCC,setMailBCC] = useState<any>([])
    const [mailSubject,setMailSubject] = useState("")
    const [content, setContent] = useState<any>('')
    const [signatureList, setSignatureList] = useState<any>('')
    const [selectedSignature, setSelectedSignature] = useState<any>('')
    const [mailBody, setMailBody] = useState<any>("")
    const [oldMailBody,setOldMailBody] = useState<any>("")
    const [base64, setBase64] = useState<any>([])
    const [isSignatureCall, setIsSignatureCall] = useState(false)
    const [mailToError,setMailToError] = useState<any>("")
    const [mailSubjectError,setMailSubjectError] = useState<any>("")
    const [contentError,setContentError] = useState<any>("")
    const [fromEmailList, setFromEmailList] = useState<any>([])
    const [selectedFromEmail, setSelectedFromEmail] = useState<any>("")
    const [fromEmailError, setFromEmailError] = useState<any>("")
    const [signatureError, setSignatureError] = useState<any>("")
    const [templateList, setTemplateList] = useState<any>("")
    const [selectedTemplate, setSelectedTemplate] = useState<any>("")
    const [loader, setLoader] = useState<any>(false)
    const [selectedFiles, setSelectedFiles] = useState<any>([])
    const [selectedFileName, setSelectedFileName] = useState<any>([])
    const [lastAction, setLastAction] = useState(0);

    let joditEditor = useRef("")

    const showCC = () => setIsEnableCC(true)
    const showBCC = () => setIsEnableBCC(true)
    const handleClose = () => {
        joditEditor.current = ""
        setShow(false);
        setContent("")
        //setMailBody("")
        setSelectedFiles([])
        setSelectedFileName([])
        setMailSubject("")
        setMailTo("")
        setMailCC("")
        setSelectedTemplate("")
        setSelectedSignature("")
        dispatch(emailSliceAction.setEmailAction(""))
    };
    const handleShow = () => setShow(true);

    useEffect(()=>{
        const getEmailSignatureData = async () => {
            if(!isSignatureCall) {
                let username = agentObj.getConfiguration().username;
                let result = await getEmailSignatureList(username)
                if(result.data.body) {
                    setSignatureList(result?.data?.body?.Items)
                }
                setIsSignatureCall(true)
            }
            let routingProfile = agentObj.getRoutingProfile().name
            let emailList = await getEmailSenderList(routingProfile)
            if(emailList) {
                setFromEmailList(emailList)
            }
        }
        getEmailSignatureData()
        getEmailTemplate()

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(()=>{
        if(emailAction === "ReplyAll") {
            setMailTo(emailDetails.from.map((item:any) => item.address).toString())
            let ccData = emailDetails.cc.map((item:any) => item.address).toString();
            if(ccData) {
                setIsEnableCC(true)
                setMailCC(emailDetails.cc.map((item:any) => item.address).toString())
            }
            setMailSubject(emailDetails.subject)
            joditEditor.current += emailDetails.body
            //setOldMailBody(emailDetails.body)
            handleShow()
        } else if(emailAction === "Reply") {
            setMailTo(emailDetails.from.map((item:any) => item.address).toString())
            setIsEnableCC(false)
            setMailCC([])
            setMailSubject(emailDetails.subject)
            joditEditor.current += emailDetails.body
            //setOldMailBody(emailDetails.body)
            handleShow()
        } else if(emailAction === "Forward") {
            setMailTo([])
            setIsEnableCC(false)
            setMailCC([])
            setMailSubject(emailDetails.subject)
            joditEditor.current += emailDetails.body
            //setOldMailBody(emailDetails.body)
            handleShow()
        } else {
            //setOldMailBody(content)
            handleClose()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[emailAction])

    const getEmailTemplate = async () => {
        setLoader(true)
        let routingProfile = agentObj.getRoutingProfile().name;
        let result = await getEmailTemplateList(routingProfile)
        if(result.success) {
            setTemplateList(result?.data?.body?.Items)
            setLoader(false)
        }
        setLoader(false)
    }

    const onSubmit = async (e:any) => {
        e.preventDefault()
        if(selectedFromEmail === "") {
            setFromEmailError("Please select an origin email address")
            return false;
        } else if(mailTo.length === 0) {
            setMailToError("Please enter a destination email address")
            return false;
        } else if(mailSubject === "") {
            setMailSubjectError("Please enter the mail subject")
            return false;
        } else if(selectedSignature === "") {
            setSignatureError("Please select a signature")
            return false;
        } else if(joditEditor.current === "") {
            setContentError("Please enter the mail content")
            return false;
        } 
        setIsDisabled(true)
        let requestData:any = {
            mailFrom:selectedFromEmail,
            mailTo:mailTo,
            mailCC:mailCC,
            mailBCC:mailBCC,
            mailSubject:mailSubject,
            mailBody:joditEditor.current,
            attachment:base64,
            date:new Date(),
            AgentName:agentObj.getName(),
        }
        let result = await sendRawEmail(requestData)
        if(result.success) {
            handleClose()
            setMailTo([])
            setMailCC([])
            setMailBCC([])
            setMailSubject("")
            setSelectedFiles([])
            setSelectedFileName([])
            setBase64([])
            console.log("Email sent successfully")
        } else {
            console.log("Failed to send email")
        }
        setIsDisabled(false)
    }

    const onAttachmentChange = async(e:any) => {
        const newFilePromises = selectedFiles
        const newFileName = selectedFileName
        for (let i = 0; i < e.target.files.length; i++) {
            newFilePromises.push(fileToDataUri(e.target.files[i]))
            newFileName.push(e.target.files[i].name)
        }
        setSelectedFileName(newFileName)
        setSelectedFiles(newFilePromises)
        const newFile = await Promise.all(newFilePromises)
        setBase64(newFile)
    }

    const fileToDataUri = (image:any) => {
        return new Promise((res) => {
          const reader = new FileReader();
          const {type, name, size} = image;
          reader.addEventListener('load', () => {
              res({
                  base64: reader.result,
                  name: name,
                  type,
                  size: size,
              })
          });
          reader.readAsDataURL(image);
        })
    }

    const onChangeFromEmail = (event:any) => {
        setFromEmailError("")
        setSelectedFromEmail(event.target.value)
    }

    const onChangeMailTo = (event:any) => {
        setMailToError("")
        let emailToValue = event.target.value.split(",");
        setMailTo(emailToValue)
    }
    
    const onChangeMailCC = (event:any) => {
        let emailCCValue = event.target.value.split(",");
        setMailCC(emailCCValue)
    }

    const onChangeMailBCC = (event:any) => {
        let emailBCCValue = event.target.value.split(",");
        setMailBCC(emailBCCValue)
    }

    const onChangeMailSubject = (event:any) => {
        setMailSubjectError("")
        let emailSubjectValue = event.target.value;
        setMailSubject(emailSubjectValue)
    }
    
    const onChangeMailContent = (content:any) => {
        setContentError("")
        joditEditor.current = content
        //setMailBody(content)
    }

    const onTemplateSelect = (template:any) => {
        joditEditor.current =  template+joditEditor.current
        setSelectedTemplate(template)
    }

    const onChangeSignature = (event:any) => {
        let signatureValue = signatureList.filter((item:any)=> item.signatureId === event.target.value)[0]
        if(signatureValue?.signature !== undefined){
            setSelectedSignature(signatureValue.signature)
            joditEditor.current = signatureValue.signature+joditEditor.current
        } else {
            setSelectedSignature("")
        }
    }

    const removeAttachment = async(index:number) => {
        let files = selectedFiles;
        files.splice(index, 1)
        setSelectedFiles(files)
        const newFile = await Promise.all(files)
        setBase64(newFile)
        
        let fileName = selectedFileName;
        fileName.splice(index, 1)
        setSelectedFileName(fileName)
        setLastAction(Date.now());
    }

    return (
        <React.Fragment>
            <Button className='dailbox bg-primary' onClick={handleShow}>
                <span className='dailbox-icon'><MdOutlineMail /></span>
            </Button>

            <Modal size="xl" show={show} onHide={handleClose}>
                <Modal.Header className='dailpad-header '>
                    <Modal.Title>New mail</Modal.Title>
                    <button className='close-btn-x' onClick={handleClose}>
                        <BsXLg/>
                    </button>
                </Modal.Header>
                <Modal.Body>
        <div className='row'>
            <div className='col-md-9'>
            <form className='bg-light p-3' autoComplete="off">
                    <div className="row mb-1">
                        <label className="form-label col-2">From</label>
                        <div className='col-10'>
                            {/* <select onChange={(event) => { onChangeWrapupCode(event) }} className={`form-control form-select-sm ${(warpupCodeErrorMessage !== "")?"is-invalid":""}`}> */}
                            <select onChange={(event) => { onChangeFromEmail(event) }} defaultValue={selectedFromEmail} className={`form-select form-select-sm ${(fromEmailError !== "")?"is-invalid":""}`}>
                                <option value="">Select an origin email address</option>
                                {fromEmailList?.senderEmailIds?.map((item:any, index:number) => {
                                    return (<option key={index} value={item}>{item}</option>)
                                })}
                            </select>
                            {fromEmailError && <div className='error-text text-danger'><MdOutlineErrorOutline /> {fromEmailError} </div>}
                        </div>
                    </div>
                    <div className="row mb-1">
                        <label className="form-label col-2">To</label>
                        <div className='col-10'>
                            <div className='input-group'>
                            <input onChange={(event)=>{onChangeMailTo(event)}} value={mailTo} type="email" className={`form-control form-control-sm ${(mailToError !== "")?"is-invalid":""}`} placeholder="Enter the destination email address" name="emailTo" autoComplete="off"/>
                            {mailToError && <div className='error-text text-danger'><MdOutlineErrorOutline /> {mailToError} </div>}
                            
                                {!isEnableCC && <button onClick={ () => showCC()} type="button" className='btn btn-sm btn-primary'>Add CC</button>}
                                {!isEnableBCC && <button onClick={ () => showBCC()} type="button" className='btn btn-sm btn-primary'>Add BCC</button>}
                            </div>
                        </div>
                    </div>
                    {isEnableCC && <div className="row mb-1">
                        <label className="form-label col-2">Cc</label>
                        <div className='col-10'>
                            <input onChange={(event)=>{onChangeMailCC(event)}} value={mailCC} type="email" className="form-control form-control-sm" placeholder="Enter CC email address" name="emailCC" autoComplete="off"/>
                        </div>
                    </div>}
                    {isEnableBCC && <div className="row mb-1">
                        <label className="form-label col-2">Bcc</label>
                        <div className='col-10'>
                            <input onChange={(event)=>{onChangeMailBCC(event)}} value={mailBCC} type="email" className="form-control form-control-sm" placeholder="Enter BCC email address" name="emailBCC" autoComplete="off"/>
                        </div>
                    </div>}
                    <div className="row mb-1">
                        <label className="form-label col-2">Subject</label>
                        <div className='col-10'>
                            <input onChange={(event)=>{onChangeMailSubject(event)}} value={mailSubject} type="text" className={`form-control form-control-sm ${(mailSubjectError !== "")?"is-invalid":""}`} placeholder="Enter your subject" name="suebject" autoComplete="off"/>
                            {mailSubjectError && <div className='error-text text-danger'><MdOutlineErrorOutline /> {mailSubjectError} </div>}
                        </div>
                    </div>
                    <div className="row mb-1">
                        <label className="form-label col-2">Attachment</label>
                        <div className='col-10'>
                            <div className='d-flex'>
                                <input onChange={(event) => {onAttachmentChange(event)}} className='form-control form-control-sm' type="file" multiple />
                            </div>
                            <div className='d-flex flex-wrap mt-1'>
                            {selectedFileName && selectedFileName?.map((item:any, index:number) => {
                                return (<span className='select-img' key={index}>{item} <span className='text-danger' onClick={()=>{removeAttachment(index)}}><RiCloseCircleLine /></span></span>)
                            })}
                            </div>
                        </div>
                    </div>
                    <div className="row mb-1">
                        <label className="form-label col-2">Signature</label>
                        <div className='col-10'>
                            <select onChange={(event) => { onChangeSignature(event) }} className={`form-select form-select-sm ${(signatureError !== "")?"is-invalid":""}`}>
                                <option value="">Select signature</option>
                                {signatureList && signatureList?.map((item:any, index:number) => {
                                    return (<option key={index} value={item.signatureId}>{item.signatureName}</option>)
                                })}
                            </select>
                            {signatureError && <div className='error-text text-danger'><MdOutlineErrorOutline /> {signatureError} </div>}
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-12'>
                            <label className="form-label">Message</label>
                            {(joditEditor.current===""&&<JoditEditor
                                value={joditEditor.current}
                                config = {OptionsJodit}
                                //config={{
                                //    readonly: false,
                                //    placeholder: 'Start typings...', 
                                //    buttons: ["bold","italic","underline","strikethrough","eraser","ul","ol","font","fontsize","brush","paragraph","table","lineHeight","superscript","subscript","preview"],
                                //    toolbarAdaptive: false,
                                //}}
                                onBlur={newContent => onChangeMailContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                onChange={newContent => {}}
                            />)}{(joditEditor.current!==""&&<JoditEditor
                            value={joditEditor.current}
                            config = {OptionsJodit}
                            onBlur={newContent => onChangeMailContent(newContent)} // preferred to use only this option to update the content for performance reasons
                            onChange={newContent => {}}
                        />)
                            }
                            {contentError && <div className='error-text text-danger'><MdOutlineErrorOutline /> {contentError} </div>}
                        </div>
                    </div>
                </form>
            </div>
            <div className='col-md-3'>
                <div className='bg-light p-3'>
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">#/10</th>
                            <th scope="col">Template name</th>
                        </tr>
                    </thead>
                    <tbody>
                    {loader && <Spinner animation="border" variant="primary" />}
                    {(!loader && templateList !=='') && templateList.map((item:any, index:number) => {
                        return (
                            <tr key={index} onClick={()=>{onTemplateSelect(item.emailTemplate)}}>
                                <th scope="row">{index+1 + "/10"}</th>
                                <td><span className='text-link'>{item.templateName}</span></td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
                </div>
            </div>
        </div>
                
                
                </Modal.Body>
                <Modal.Footer>
                    <button disabled={isDisabled} onClick={(event)=>{onSubmit(event)}} type="button" className="btn btn-primary">
                        {isDisabled && <Spinner as="span"animation="grow" size="sm" role="status" aria-hidden="true"/>} <RiSendPlaneLine /> Send email
                    </button>
                    <button onClick={handleClose} type="button" className="btn btn-danger"><RiCloseCircleLine /> Discard</button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}
export default Dailpad;